import React from 'react';
import { Box, Text } from '@razorpay/blade/components';
import { useQuery } from 'react-query';
import api from 'api';
import officeLocationIcon from 'assets/officeLocation/office-location-icon.png';
import { getStaticMediaUrl } from 'utils/Urls';
import { officeLocationQueryKeys } from './data';

export const RegisteredOffice = () => {
  const { data } = useQuery({
    queryKey: [officeLocationQueryKeys.GET_OFFICE_LOCATIONS_PRIMARY],
    queryFn: () =>
      api.officeLocation.fetchOfficeLocations({
        limit: 10,
        page: 1,
        isPrimary: true,
      }),
  });
  const officeLocation = data?.data?.[0];

  if (!officeLocation) {
    return null;
  }
  return (
    <Box display="flex" alignItems="flex-start" gap="spacing.3" marginBottom="spacing.7">
      <img
        src={getStaticMediaUrl(officeLocationIcon)}
        alt=""
        width="42px"
        height="auto"
      />
      <Box>
        <Text size="large" weight="semibold" color="surface.text.gray.normal">
          Registered Office
        </Text>
        <Text size="small" weight="regular" color="surface.text.gray.muted" marginTop="spacing.2">
          {`${officeLocation.address_line_1} ${officeLocation.address_line_2}, ${
            officeLocation.district
          }, ${officeLocation.state}, ${officeLocation.pincode}${
            officeLocation.esic_dispensary
              ? `, ESIC Dispensary: ${officeLocation.esic_dispensary}`
              : ''
          }${
            officeLocation.esic_sub_code ? `, ESIC Subcode: ${officeLocation.esic_sub_code}` : ''
          }`}
        </Text>
      </Box>
    </Box>
  );
};
